module.exports = __webpack_public_path__ + "static/me-d6cad76a9bcbc69c4ae72a0731d270d0.png";